import { PureComponent } from "react";
import classnames from "classnames";

import colors from "/styles/colors";

import { StyledSwitchingWordsComponent } from "./switching-words-component.scss";

export default class SwitchingWordsComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: props.activeIndex,
      prevActiveIndex: null
    };

    this._isMounted = false;

    this.changeActiveIndex = this.changeActiveIndex.bind(this);
    this.renderWord = this.renderWord.bind(this);

    this._changeActiveIndexInterval = null;
  }

  componentDidMount() {
    const { animationInterval } = this.props;
    if (animationInterval) {
      this._changeActiveIndexInterval = setInterval(this.changeActiveIndex, animationInterval);
    }

    this._isMounted = true;
  }

  componentWillUnmount() {
    clearInterval(this._changeActiveIndexInterval);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeIndex != this.state.activeIndex) {
      this.setState({ activeIndex: nextProps.activeIndex, prevActiveIndex: this.state.activeIndex });
    }
  }

  changeActiveIndex() {
    const { words } = this.props;
    const { activeIndex } = this.state;

    const nextActiveIndex = (activeIndex + 1) % words.length;
    this.setState({ activeIndex: nextActiveIndex, prevActiveIndex: activeIndex });
  }

  shouldAnimateWordEntrance(wordIndex) {
    const { skipAnimation } = this.props;
    if (skipAnimation) return false;
    const { activeIndex } = this.state;
    return activeIndex === wordIndex && this._isMounted;
  }

  shouldAnimateWordExit(wordIndex) {
    const { skipAnimation } = this.props;
    if (skipAnimation) return false;

    const { activeIndex, prevActiveIndex } = this.state;
    return prevActiveIndex === wordIndex && this._isMounted;
  }

  renderWord(word, index) {
    const { activeIndex, prevActiveIndex } = this.state;
    const { text, color } = word;

    const style = { color: colors[color] };
    const active = activeIndex === index;

    const animateEntrance = this.shouldAnimateWordEntrance(index);
    const animateExit = this.shouldAnimateWordExit(index);

    return (
      <div
        key={index}
        className={classnames("switching-word-item-wrapper", {
          active,
          "animate-entrance": animateEntrance,
          "animate-exit": animateExit
        })}
        style={style}
      >
        {text}
      </div>
    );
  }

  render() {
    const { words, wordWidth } = this.props;
    return (
      <StyledSwitchingWordsComponent className="switching-words-component" style={{ width: wordWidth }}>
        {words.map(this.renderWord)}
      </StyledSwitchingWordsComponent>
    );
  }
}

SwitchingWordsComponent.defaultProps = {
  words: [],
  activeIndex: 0,
  skipAnimation: false
};
